import React from 'react';
import { DOTS, usePagination } from 'Hooks/usePagination';
import {
	NavigationButton,
	PaginationContainer,
	PaginationItem,
	PaginationWrapper,
} from './Pagination.styles';
import { ApIcon } from '@alixpartners/ui-components';
import PropTypes from 'prop-types';

const Pagination = props => {
	const {
		onPageChange,
		totalCount,
		siblingCount = 1,
		currentPage,
		pageSize,
		position = 'start',
	} = props;

	const paginationRange = usePagination({
		currentPage,
		totalCount,
		siblingCount,
		pageSize,
	});

	if (currentPage === 0 || paginationRange.length < 2) {
		return null;
	}

	const onNext = () => onPageChange(currentPage + 1);

	const onPrevious = () => onPageChange(currentPage - 1);

	let lastPage = paginationRange[paginationRange.length - 1];

	return (
		<PaginationWrapper position={position}>
			<PaginationContainer>
				<NavigationButton onClick={onPrevious} disabled={currentPage === 1}>
					<ApIcon
						material={true}
						iconName="keyboard_arrow_left"
						className="left_arrow"
						title="Previous"
						iconSize="19px"
					/>
				</NavigationButton>

				{paginationRange.map((pageNumber, index) => {
					if (pageNumber === DOTS) {
						return (
							<PaginationItem key={`${pageNumber}_${index}`} dots={true}>
								&#8230;
							</PaginationItem>
						);
					}
					return (
						<PaginationItem
							key={`${pageNumber}_${index}`}
							selected={pageNumber === currentPage}
							onClick={() => onPageChange(pageNumber)}
						>
							{pageNumber}
						</PaginationItem>
					);
				})}
				<NavigationButton onClick={onNext} disabled={currentPage === lastPage}>
					<ApIcon
						material={true}
						iconName="keyboard_arrow_right"
						className="right_arrow"
						title="Next"
						iconSize="19px"
					/>
				</NavigationButton>
			</PaginationContainer>
		</PaginationWrapper>
	);
};

Pagination.propTypes = {
	currentPage: PropTypes.number.isRequired,
	totalCount: PropTypes.number.isRequired,
	pageSize: PropTypes.number.isRequired,
	onPageChange: PropTypes.func.isRequired,
	position: PropTypes.oneOf(['start', 'center', 'end']),
};

export default Pagination;
